@if (point(); as point) {
  <div class="set">
    @if (showHeading()) {
      <p class="f-body-l f-semibold">
        {{
          [vehicleSet().vehicle, vehicleSet().trailer]
            | fleetIdentifier: 'registrationNumber'
        }}
      </p>
    }

    @if (tooltip(); as tooltip) {
      <onyx-message intent="neutral">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        {{ tooltip | translate }}
      </onyx-message>
    }

    <app-route-point-status-form
      [point]="point"
      variant="modal"
      [disabled]="isDisabled()"
    ></app-route-point-status-form>
  </div>
}
